"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
const react_1 = __importStar(require("react"));
const react_intersection_observer_1 = require("react-intersection-observer");
const isBoolean_1 = __importDefault(require("lodash/isBoolean"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const noop_1 = __importDefault(require("lodash/noop"));
const range_1 = __importDefault(require("lodash/range"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const monera_app_core_2 = require("@amzn/monera-app-core");
const common_1 = require("../common");
const styles_1 = require("./styles");
const RIGHT_ARROW_DELAY_TIME_IN_MILLIS = 100;
const Carousel = (props) => {
    const { elements = [], title = '', onPagination = noop_1.default, showPaginationButtons = true, leftPaginationButtonDistance = '30px', rightPaginationButtonDistance = '30px', showPaginationDots = true, paginationDotsClickable = true, paginateWholePage = true, hidden = false, slidesAnimated = true, renderSlide = (el) => el, showFocusElement = false, renderFocusSlide = (component) => component, initialFocusSlideIndex = 0, slidesPerPage = 5, circularPaging = true, renderPageIndicators, allowScrolling = false, arrowKeyNavigation = false, lazyLoadElements = false, width = undefined, imageMargins = '0px', useFillerSlides = true, useAutoSlideWidth = true, hidePaginationButtonsAtEnds = true, paginationButtonEdgeStyles = {}, hideLeftPaginationButtonOnFirstLoad = false, delayRightArrowRender = false } = props;
    const [isFirstLoad, setIsFirstLoad] = (0, react_1.useState)(true);
    const [isDelayRightArrowRender, setDelayRightArrowRender] = (0, react_1.useState)(delayRightArrowRender);
    const { breakpoint } = (0, monera_app_core_2.useResponsiveLayout)();
    const calculateRealSlidesPerPage = () => {
        if ((0, isNumber_1.default)(slidesPerPage)) {
            return paginateWholePage ? slidesPerPage : 1;
        }
        const currentBreakpoint = breakpoint();
        return currentBreakpoint ? slidesPerPage[currentBreakpoint] : 0;
    };
    const calculatePageCount = () => {
        if ((0, isNumber_1.default)(slidesPerPage)) {
            return elements.length / slidesPerPage > 1 ? elements.length : 1;
        }
        return elements.length;
    };
    const [pageCount, setPageCount] = (0, react_1.useState)(calculatePageCount());
    const [currentPage, setCurrentPage] = (0, react_1.useState)(0);
    const [previousPage, setPreviousPage] = (0, react_1.useState)();
    const [realSlidesPerPage, setRealSlidesPerPage] = (0, react_1.useState)(calculateRealSlidesPerPage());
    const [focusElementIndex, setFocusElementIndex] = (0, react_1.useState)(initialFocusSlideIndex);
    const renderedElements = new Array();
    const [intersecting, setIntersecting] = (0, react_1.useState)(false);
    const { ref, inView } = (0, react_intersection_observer_1.useInView)({ rootMargin: '0px 0px 300px 0px' });
    const rowContainerRef = (0, react_1.useRef)(null);
    const slideRefs = (0, react_1.useRef)([]);
    const { windowSize, deviceType } = (0, monera_app_core_2.useResponsiveLayout)();
    const isDesktop = deviceType() === monera_app_core_1.DeviceType.Desktop;
    (0, react_1.useEffect)(() => {
        setRealSlidesPerPage(calculateRealSlidesPerPage());
    }, [slidesPerPage]);
    (0, react_1.useEffect)(() => {
        if (isDelayRightArrowRender) {
            setTimeout(() => {
                setDelayRightArrowRender(false);
            }, RIGHT_ARROW_DELAY_TIME_IN_MILLIS);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (paginateWholePage) {
            setPageCount(Math.ceil(elements.length / Math.floor(realSlidesPerPage)));
        }
        else {
            setPageCount(Math.ceil(elements.length));
        }
    }, [elements, paginateWholePage, realSlidesPerPage]);
    (0, react_1.useEffect)(() => {
        setInitialSlide();
    }, [initialFocusSlideIndex]);
    (0, react_1.useEffect)(() => onPagination(previousPage, currentPage), [currentPage]);
    (0, react_1.useEffect)(() => {
        if (inView) {
            setIntersecting(true);
        }
    }, [inView]);
    (0, react_1.useEffect)(() => {
        if (isDesktop) {
            const pageIndex = initialFocusSlideIndex === 'none' ? currentPage : focusElementIndex === 'none' ? 0 : focusElementIndex;
            scrollToPage(pageIndex, false);
        }
    }, [windowSize.width, windowSize.height]);
    const setInitialSlide = () => {
        let page = 0;
        if (initialFocusSlideIndex !== 'none') {
            page = Math.floor(initialFocusSlideIndex / realSlidesPerPage);
            setCurrentPage(page);
        }
        scrollToPage(page, false);
    };
    let numberOfFillerSlides = 0;
    if (useFillerSlides) {
        numberOfFillerSlides = Math.floor(realSlidesPerPage) - (elements.length % Math.floor(realSlidesPerPage));
        numberOfFillerSlides = numberOfFillerSlides === Math.floor(realSlidesPerPage) ? 0 : numberOfFillerSlides;
    }
    const realPageCount = paginateWholePage ? pageCount : numberOfFillerSlides + pageCount;
    const setPage = (pageIndex) => (event) => {
        if ((0, isBoolean_1.default)(pageIndex)) {
            pageIndex = currentPage + (pageIndex ? 1 : -1);
        }
        event.stopPropagation();
        let newPageIndex = pageIndex;
        if (circularPaging) {
            if (pageIndex < 0) {
                newPageIndex = pageCount - 1;
            }
            else if (pageIndex >= pageCount) {
                newPageIndex = 0;
            }
        }
        else {
            if (pageIndex < 0) {
                newPageIndex = 0;
            }
            else if (pageIndex >= pageCount) {
                newPageIndex = pageCount - 1;
            }
        }
        initialFocusSlideIndex !== 'none' && setFocusElementIndex(newPageIndex);
        scrollToPage(newPageIndex, slidesAnimated);
        if (!allowScrolling && newPageIndex !== currentPage) {
            setPreviousPage(currentPage);
            setCurrentPage(newPageIndex);
        }
    };
    const scrollToPage = (page, animated) => {
        const el = rowContainerRef.current;
        const slideEl = slideRefs.current[0];
        const slideLength = slideEl.clientWidth;
        const imageMarginLength = parseInt(imageMargins, 10) | 0;
        if (el && el.scrollTo) {
            el.scrollTo({
                behavior: animated ? 'smooth' : 'auto',
                left: Math.ceil(realSlidesPerPage * page) * (slideLength + imageMarginLength)
            });
        }
    };
    const setFocus = (index) => (event) => {
        var _a, _b;
        if (event.target.tagName === common_1.TagName.Button ||
            event.target.tagName === common_1.TagName.Image ||
            ((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.firstChild) === null || _b === void 0 ? void 0 : _b.tagName) === common_1.TagName.Video) {
            event.stopPropagation();
        }
        setFocusElementIndex(index);
    };
    const applyRenderCallbacks = (element, isFocusElement, index) => {
        if (!renderedElements.includes(index)) {
            renderedElements.push(index);
        }
        if (showFocusElement && isFocusElement) {
            return renderFocusSlide(element, index);
        }
        else if (renderSlide) {
            return renderSlide(element, index);
        }
        else {
            return element;
        }
    };
    const allowSnap = (index) => index % Math.floor(realSlidesPerPage) === 0 || !paginateWholePage;
    const slides = elements.map((element, index) => {
        const shouldRenderElement = !lazyLoadElements ||
            (intersecting && index < (currentPage + 2) * realSlidesPerPage) ||
            renderedElements.includes(index);
        return (react_1.default.createElement(styles_1.Slide, { useAutoSlideWidth: useAutoSlideWidth, slidesPerPage: slidesPerPage, index: index, key: index, showFocusElement: showFocusElement, allowSnap: allowSnap(index), imageMargins: imageMargins, carouselWidth: width, "data-cy": `slide${index}`, ref: (el) => slideRefs.current.push(el), onClick: setFocus(index) }, shouldRenderElement ? applyRenderCallbacks(element, focusElementIndex === index, index) : react_1.default.createElement(styles_1.PlaceholderSlide, null)));
    });
    if (numberOfFillerSlides > 0) {
        slides.push(...new Array(numberOfFillerSlides)
            .fill(null)
            .map((_, i) => (react_1.default.createElement(styles_1.Slide, { slidesPerPage: slidesPerPage, key: i + slides.length, index: i + slides.length, showFocusElement: false, allowSnap: allowSnap(i + slides.length), imageMargins: imageMargins, carouselWidth: width }))));
    }
    const pageIndicators = () => (renderPageIndicators &&
        renderPageIndicators(pageCount, currentPage, paginationDotsClickable ? (page, event) => setPage(page)(event) : noop_1.default)) ||
        defaultPageIndicator();
    const defaultPageIndicator = () => (react_1.default.createElement(styles_1.PageIndicatorContainer, null, (0, range_1.default)(pageCount).map((index) => (react_1.default.createElement(styles_1.PageIndicator, { key: index, active: index === currentPage, clickable: paginationDotsClickable, onClick: paginationDotsClickable ? setPage(index) : noop_1.default })))));
    const renderLeftButton = () => {
        if (!showPaginationButtons) {
            return null;
        }
        const onClick = setPage(false);
        const { renderLeftPaginationButton } = props;
        if (!circularPaging && currentPage === 0) {
            if (hidePaginationButtonsAtEnds || (isFirstLoad && hideLeftPaginationButtonOnFirstLoad)) {
                return null;
            }
            if (paginationButtonEdgeStyles) {
                return (react_1.default.createElement(styles_1.LeftButtonContainer, { leftPaginationButtonDistance: leftPaginationButtonDistance, style: paginationButtonEdgeStyles }, (renderLeftPaginationButton && renderLeftPaginationButton(onClick)) || (react_1.default.createElement(styles_1.LeftButton, { "data-cy": 'media-carousel-modal-left-button', onClick: onClick }))));
            }
        }
        return (react_1.default.createElement(styles_1.LeftButtonContainer, { leftPaginationButtonDistance: leftPaginationButtonDistance }, (renderLeftPaginationButton && renderLeftPaginationButton(onClick)) || (react_1.default.createElement(styles_1.LeftButton, { "data-cy": 'media-carousel-modal-left-button', onClick: onClick }))));
    };
    const renderRightButton = () => {
        if (!showPaginationButtons) {
            return null;
        }
        if (isDelayRightArrowRender) {
            return null;
        }
        const onClick = (event) => {
            setIsFirstLoad(false);
            setPage(true)(event);
        };
        const { renderRightPaginationButton } = props;
        if (!circularPaging && currentPage === realPageCount - 1) {
            if (hidePaginationButtonsAtEnds || currentPage == 0) {
                return null;
            }
            if (paginationButtonEdgeStyles) {
                return (react_1.default.createElement(styles_1.RightButtonContainer, { rightPaginationButtonDistance: rightPaginationButtonDistance, style: paginationButtonEdgeStyles }, (renderRightPaginationButton && renderRightPaginationButton(onClick)) || (react_1.default.createElement(styles_1.RightButton, { "data-cy": 'media-carousel-modal-right-button', onClick: onClick }))));
            }
        }
        return (react_1.default.createElement(styles_1.RightButtonContainer, { rightPaginationButtonDistance: rightPaginationButtonDistance }, (renderRightPaginationButton && renderRightPaginationButton(onClick)) || (react_1.default.createElement(styles_1.RightButton, { "data-cy": 'media-carousel-modal-right-button', onClick: onClick }))));
    };
    const onScroll = () => {
        const el = rowContainerRef.current;
        if (!el) {
            return;
        }
        const slideEl = slideRefs.current[0];
        const slideLength = slideEl.clientWidth;
        const imageMarginLength = parseInt(imageMargins, 10) | 0;
        let page = el.scrollLeft / (slideLength + imageMarginLength) / realSlidesPerPage;
        page = Math.min(Math.max(page, 0), pageCount);
        if (allowScrolling && page !== currentPage) {
            setPreviousPage(currentPage);
            setCurrentPage(page);
        }
    };
    (0, monera_app_core_2.useKeyEvent)(monera_app_core_2.LpKeyEventDirection.Down, noop_1.default, { enabled: arrowKeyNavigation, targetKeys: ['ArrowLeft', 'ArrowRight'] });
    (0, monera_app_core_2.useKeyEvent)(monera_app_core_2.LpKeyEventDirection.Up, setPage(false), { enabled: arrowKeyNavigation, targetKeys: ['ArrowLeft'] });
    (0, monera_app_core_2.useKeyEvent)(monera_app_core_2.LpKeyEventDirection.Up, setPage(true), { enabled: arrowKeyNavigation, targetKeys: ['ArrowRight'] });
    return (react_1.default.createElement(styles_1.CarouselCore, { hidden: hidden, width: width },
        title && react_1.default.createElement(styles_1.Title, null, title),
        react_1.default.createElement(styles_1.CarouselContainer, { ref: ref },
            renderLeftButton(),
            renderRightButton(),
            react_1.default.createElement(styles_1.RowContainer, { ref: rowContainerRef, allowScrolling: allowScrolling, currentPage: currentPage, slidesAnimated: slidesAnimated, paginateWholePage: paginateWholePage, "data-cy": "row-container", onScroll: onScroll },
                react_1.default.createElement(styles_1.Row, { "data-cy": "row" }, slides))),
        showPaginationDots ? pageIndicators() : null));
};
exports.Carousel = Carousel;
exports.default = exports.Carousel;
